import { node, object, string } from "prop-types";
import React, { useContext, useMemo } from "react";
import useIsomorphicEffect from "../isomorphic-effect";
import i18Context from "./context";
import translatorFactory from "./translator";

const LocaleProvider = ({ language, resources, children, ...options }) => {
	const currentContext = useContext(i18Context);
	const parent = currentContext?.i18;
  const lang = parent?.language ?? language; // eslint-disable-line

	const translator = useMemo(
		() => translatorFactory({ parent, resources, ...options, lng: lang }), //
		[language, parent], //
	);

	useIsomorphicEffect(
		() => translator.release, // unbinding from parent
		[translator],
	);

	useIsomorphicEffect(
		() => {
			if (lang === translator.i18.language) return;
			translator.setLanguage(lang);
		}, // updating language from props
		[lang, translator],
	);

	return <i18Context.Provider value={translator}>{children}</i18Context.Provider>;
};

LocaleProvider.propTypes = {
	language: string,
	resources: object.isRequired, // eslint-disable-line react/forbid-prop-types
	children: node,
};

export default LocaleProvider;
